export default __webpack_public_path__ + "static/media/nft_project.ec5c7162.png";